export const XP_ACTIONS = {
  RECORD_GAME_SESSION: 'record_game_session',
  RATE_GAME: 'rate_game',
  CREATE_POST: 'create_post',
  LIKE_POST: 'like_post',
  RECEIVE_LIKE: 'receive_like',
  COMMENT_POST: 'comment_post',
  RATE_COMPLEXITY: 'rate_complexity',
  ADD_GAME_TO_COLLECTION: 'add_game_to_collection',
  ADD_GAME_TO_WISHLIST: 'add_game_to_wishlist',
  ESTABLISH_CONNECTION: 'establish_connection',
  CREATE_MARKET_LISTING: 'create_market_listing',
  COMPLETE_MARKET_LISTING: 'complete_market_listing',
  UPDATE_PROFILE: 'update_profile',
  DAILY_LOGIN: 'daily_login',
  CLICK_AFFILIATE_LINK: 'click_affiliate_link',
  // Adicionar outras chaves conforme forem implementadas
  // Ex:
  // LIKE_POST: 'like_post',
  // RECEIVE_LIKE: 'receive_like',
  // ADD_COMMENT: 'add_comment',
  // RATE_COMPLEXITY: 'rate_complexity',
  // ADD_GAME_TO_COLLECTION: 'add_game_to_collection',
  // ADD_GAME_TO_WISHLIST: 'add_game_to_wishlist',
  // ESTABLISH_CONNECTION: 'establish_connection',
  // CREATE_MARKET_LISTING: 'create_market_listing',
  // COMPLETE_MARKET_LISTING: 'complete_market_listing',
  // UPDATE_PROFILE: 'update_profile',
  // DAILY_LOGIN: 'daily_login',
  // CLICK_AFFILIATE_LINK: 'click_affiliate_link',
  REFERRAL_REGISTRATION: 'referral_registration', // Fase 5
  REFERRAL_MILESTONE: 'referral_milestone', // Fase 5
} as const;

export type XpActionKey = typeof XP_ACTIONS[keyof typeof XP_ACTIONS]; 